// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  specId: __t.u64().primaryKey().name("spec_id"),
  name: __t.string(),
  specJson: __t.string().name("spec_json"),
  createdAt: __t.timestamp().name("created_at"),
  createdBy: __t.string().name("created_by"),
});
